import { withRouteParams } from 'shared/hoc'

import CarPark from './CarPark'

const CarParkView = ({ language, locationId }) => (
    <CarPark language={language} locationId={locationId} key={`${language}-${locationId}`} />
)

export default withRouteParams(CarParkView)
